export const toDateOnly = (
  value: Date | string | null | undefined,
): Date | undefined => {
  if (!value) {
    return undefined;
  }
  const d = new Date(value);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
};
